import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import emptyFunction from 'react-utils/emptyFunction';
import UIButton from 'UIComponents/button/UIButton';
import handleCallback from '../lib/handleCallback';
import TourContext from '../contexts/TourContext';

const UITourFinishButton = props => {
  const {
    tour
  } = useContext(TourContext);

  const {
    beforeFinish,
    children = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "shepherd-react.finish"
    })
  } = props,
        buttonProps = _objectWithoutPropertiesLoose(props, ["beforeFinish", "children"]);

  const {
    finish,
    getTour,
    getStep
  } = tour;

  const handleClick = () => handleCallback(beforeFinish, finish, {
    tourKey: getTour(),
    stepKey: getStep()
  });

  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};

UITourFinishButton.propTypes = {
  beforeFinish: PropTypes.func.isRequired,
  children: PropTypes.node
};
UITourFinishButton.defaultProps = {
  beforeFinish: emptyFunction
};
export default UITourFinishButton;